import './component.scss';
import '@stimulus/polyfills'
import { Application, Controller } from 'stimulus'

const app = Application.start()

app.register('refosumu-company-show-basic-info', class extends Controller {
  static targets = ["tab", "content"]

  // タブ切り替え機能
  switchTab(event) {
    const targetTab = event.currentTarget.dataset.tab
    
    // すべてのタブの active クラスを削除
    this.tabTargets.forEach(tab => tab.classList.remove('active'))
    this.contentTargets.forEach(content => content.classList.remove('active'))
    
    // クリックされたタブと対応するコンテンツに active クラスを追加
    event.currentTarget.classList.add('active')
    const targetContent = this.contentTargets.find(content => 
      content.dataset.content === targetTab
    )
    if (targetContent) {
      targetContent.classList.add('active')
    }
  }
})
